import { LiveStreamingStates, ShowType } from "../models";
var RecentShowMaxAgeInHours = 24;
var subtractHoursToDate = function subtractHoursToDate(date, hours) {
  return new Date(new Date(date).setHours(date.getHours() - hours));
};
export var getLiveStreamingStateByVideoConfig = function getLiveStreamingStateByVideoConfig(_ref) {
  var isVideoShoppingEnabled = _ref.isVideoShoppingEnabled,
    currentVideoShow = _ref.currentVideoShow;
  var _ref2 = currentVideoShow !== null && currentVideoShow !== void 0 ? currentVideoShow : {},
    endedAtUtc = _ref2.endedAtUtc,
    typeOfShow = _ref2.typeOfShow;
  if (isVideoShoppingEnabled) {
    switch (typeOfShow) {
      case ShowType.Live:
        return LiveStreamingStates.IS_LIVE;
      case ShowType.Scheduled:
        return LiveStreamingStates.PLANNED;
      case ShowType.Ended:
        {
          if (endedAtUtc) {
            var endedAtUtcDate = new Date(endedAtUtc);
            return subtractHoursToDate(new Date(), RecentShowMaxAgeInHours) <= endedAtUtcDate ? LiveStreamingStates.WAS_LIVE : LiveStreamingStates.UNKNOWN;
          }
          break;
        }
      default:
        return LiveStreamingStates.UNKNOWN;
    }
  }
  return LiveStreamingStates.UNKNOWN;
};